var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65 439 c-20 -18 -35 -40 -35 -53 1 -107 249 -355 356 -356 24 0 84 61 84 85 0 8 -25 31 -55 52 -55 36 -56 36 -89 20 l-33 -15 -61 61 -60 62 16 32 c15 32 15 33 -21 88 -21 30 -44 55 -52 55 -8 0 -30 -14 -50 -31z m86 -35 c29 -42 30 -48 18 -72 -7 -15 -15 -30 -17 -34 -4 -9 105 -126 130 -139 11 -6 26 -4 46 8 28 16 30 16 75 -16 26 -17 47 -35 47 -40 0 -4 -13 -20 -29 -35 -34 -32 -59 -31 -121 7 -51 31 -176 153 -209 206 -46 71 -49 97 -15 132 15 16 31 29 35 29 5 0 22 -21 40 -46z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallDark);
export default __webpack_public_path__ + "static/media/call-dark.af56c627f7d5f9416bec4e75023bf0ed.svg";
export { ForwardRef as ReactComponent };